import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import store from './store'
import router from './router'
import vuetify from './plugins/vuetify'

window.Pusher = require('pusher-js');

import CKEditor from 'ckeditor4-vue';
Vue.use( CKEditor );

Vue.config.productionTip = false

window.urlBuilder = function (entities, url, options, headers) {
    let urlParams = new URLSearchParams();

    if (options?.type) {
        urlParams.append('type', options.type);
    }

    if (Object.keys(options).length) {
        urlParams.append('page', options.page ?? 1);
        urlParams.append('per_page', options.itemsPerPage ?? 10);
    }

    if (options?.sortBy?.length) {
        const header = headers.find(h => h.value === options.sortBy[0]);
        const sortBy = header?.original_value || options.sortBy[0];
        const sortType = options.sortDesc[0] ? 'desc' : 'asc';
        urlParams.append('sort_by', sortBy);
        urlParams.append('sort_type', sortType);
    }

    return url + '?' + urlParams.toString();
};


Vue.mixin({
    methods: {
        openSnackbar(text, color = '#696CFF') {
            this.$store.commit('setSnackbarStatus', true)
            this.$store.commit('setSnackbarText', text)
            this.$store.commit('setSnackbarColor', color)
        },
        showValidationErrors(errors) {
            let errorText = ''
            Object.entries(errors.response.data.errors).forEach((err) => {
                err[1].forEach((item) => {
                    errorText = errorText + item + '<br>'
                })
            })
            this.openSnackbar(errorText, '#d40d45')
        },
        objectParametersToString(params) {
            let stringedParams = '';
            Object.entries(params).forEach((param) => {
                if (param[1]) {
                    if (Array.isArray(param[1]) && param[1].length) {
                        param[1].forEach((item) => {
                            stringedParams = stringedParams + '&' + param[0] + '[]' + '=' + item
                        })
                    } else {
                        stringedParams = stringedParams + '&' + param[0] + '=' + param[1]
                    }
                }
            })
            return stringedParams;
        }
    },
})

new Vue({
    store,
    router,
    vuetify,
    render: h => h(App)
}).$mount('#app')
